//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AddInput from "../AddInput/index";
export default {
  props: ['data'],
  data: function data() {
    return {
      checked: true,
      //通讯协议
      ProtocolList: [{
        label: '普通串口',
        value: 'serial'
      }, {
        label: '4G DTU',
        value: 'dtu'
      }, {
        label: 'Modbus',
        value: 'modbus'
      }, {
        label: 'ZLWL',
        value: 'zlwl'
      }],
      //网络模式
      InternetList: [{
        label: '服务器',
        value: 'server'
      }, {
        label: '客户端',
        value: 'client'
      }],
      TransferProtocolList: [{
        label: 'TCP',
        value: 'tcp'
      }, {
        label: 'UDP',
        value: 'udp'
      }],
      list: {}
    };
  },
  components: {
    AddInput: AddInput
  },
  watch: {
    data: {
      handler: function handler(newValue, oldValue) {
        this.list = newValue;
        this.list.enabled = this.list.enabled == '1' ? true : false;
        this.list.hb = this.list.hb == '1' ? true : false;
        this.list.id = this.list.id == '1' ? true : false;
      }
    }
  }
};